import { auditApi as api } from '../../api';
export const addSingleClientMapping = async (formData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/create_client_template_map', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const fetchClientMapping = async () => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_client_template_maps`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const updateClientMapping = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_client_template_map/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteClientMapping = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_client_template_map/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteClientMapping = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/multiple_delete_client_template_map', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}


export const fetchClientWiseTemplate = async (clients) => {
    try {
        const response = await api.get(`/get_client_template_maps`, {
            params: {
                client_id: clients
            }
        });
        
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const fetchClientMapTemplate = async (clients) => {
    try {
        const response = await api.get('/fetch_client_template_maps', {
            params: {
                client_id: clients
            }
        });

        return response.data;
    } catch (error){
        throw error.response ? error.response.data.error : error.message;
    }
}
